export const formatDateTime = (value) => {
  if (!value) return '';

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;

  const day = `${parsed.getDate()}`.padStart(2, '0');
  const month = `${parsed.getMonth() + 1}`.padStart(2, '0');
  const hours = `${parsed.getHours()}`.padStart(2, '0');
  const minutes = `${parsed.getMinutes()}`.padStart(2, '0');

  return `${day}/${month}/${parsed.getFullYear()} ${hours}:${minutes}`;
};

export const formatDate = (value) => {
  if (!value) return '';

  // Las fechas sin hora llegan como YYYY-MM-DD. Se arman a mano porque
  // new Date('2026-09-07') se interpreta como UTC y en horario local se
  // recorreria un dia hacia atras.
  const dateOnly = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (dateOnly) {
    const [, year, month, day] = dateOnly;
    return `${day}/${month}/${year}`;
  }

  return formatDateTime(value);
};

export const formatDayMonth = (value) => {
  const formatted = formatDate(value);

  const dayMonth = /^(\d{2}\/\d{2})\/\d{4}/.exec(formatted);
  return dayMonth ? dayMonth[1] : formatted;
};
